import classnames from 'classnames';
import { observer } from 'mobx-react';
import * as React from 'react';

const styles = require('./select-option.css');

/** Props for the select option */
export interface SelectOptionProps {
  /** Additional classes to apply */
  className?: string;
  /** Label to show */
  label: string;
  /** Whether it is selected */
  selected: boolean;
  /** Callback when selection changes */
  onChange(selected: boolean): void;
  /** Color, defaults to violet */
  color?: 'violet' | 'green' | 'blue' | 'orange' | 'purple';
  /** Whether it's rounded, defaults to false */
  round?: boolean;
  /** Disabled */
  disabled?: boolean;
}

/** A single option in the spirit of a radio button */
@observer
export class SelectOption extends React.Component<SelectOptionProps> {
  /** Renders the option */
  render() {
    const color = this.props.color || 'violet';
    return (
      <div
        className={classnames(
          styles.option,
          styles[color],
          this.props.round ? styles.round : undefined,
          this.props.selected && styles.selected,
          this.props.disabled && styles.disabled,
          this.props.className
        )}
        onClick={this.onChange}
      >
        {this.props.label}
      </div>
    );
  }

  /** Callback upon change */
  onChange = () => {
    this.props.onChange(!this.props.selected);
  };
}



// WEBPACK FOOTER //
// ./src/ui/widgets/select-option/select-option.tsx